export default __webpack_public_path__ + "static/media/VN.b05bb20c.svg";